import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Header from "../header/header.js";
import PollBooth from "./poll-booth.js";
import Writeup from "./writeup.js";
import Team from "../team/team.js";

import { getVotes, getWriteups } from "../../api.js";
import { games } from "../../data/matchups";

import layout from "../layout.module.css";
import styles from "./matchup-page.module.css";

let exampleUrl = window.location.origin + "/1";

let Matchup = ({ game, votes, setVotes, writeups }) => {
  let { teamA, teamB } = game;
  let { writeupA, writeupB } = writeups;

  let writeupKeyA = teamA ? teamA.owner : "TBD_A";
  let writeupKeyB = teamB ? teamB.owner : "TBD_B";

  return (
    <>
      <div className={layout.container}>
        <div className={layout.left}>
          <Team team={teamA} />
        </div>
        {/* TODO: cool "vs" in the middle */}
        <div className={layout.right}>
          <Team team={teamB} />
        </div>
      </div>
      <PollBooth game={game} votes={votes} setVotes={setVotes} />
      <div className={layout.container}>
        <div className={[layout.left, styles.left].join(" ")}>
          <Writeup
            key={writeupKeyA}
            writeup={writeupA}
            label="writeupA"
            gameOver={game.donezo()}
          />
        </div>
        <div className={[layout.right, styles.right].join(" ")}>
          <Writeup
            key={writeupKeyB}
            writeup={writeupB}
            label="writeupB"
            gameOver={game.donezo()}
          />
        </div>
      </div>
    </>
  );
};

let MatchupPage = () => {
  let { gameNumber } = useParams();
  let game = games[gameNumber];
  let emptyVoteBox = useCallback(() => {
    return game.teamA && game.teamB
      ? {
          [game.teamA.owner]: [],
          [game.teamB.owner]: [],
        }
      : { TBD: [] };
  }, [
    game && game.teamA && game.teamA.owner,
    game && game.teamB && game.teamB.owner,
  ]);
  let [writeups, setWriteups] = useState({
    writeupA: game.writeupA,
    writeupB: game.writeupB,
  });
  let [votes, setVotes] = useState(emptyVoteBox());
  // fetch the votes to (maybe) display
  useEffect(() => {
    if (!game.teamA || !game.teamB) return;

    let exitPolls = emptyVoteBox();

    getVotes(game.number).then((votes) => {
      let recap = "";
      for (let fetchedVoter in votes) {
        let vote = votes[fetchedVoter];
        let { winner, rationale } = vote;
        exitPolls[winner] && exitPolls[winner].push(vote);
        recap =
          recap +
          `[strong]${fetchedVoter}[/strong]
[em]winner:[/em] ${winner}
${rationale ? `[em]rationale:[/em]: ${rationale}` : ""}

`;
      }

      if (game.donezo()) console.log(recap);
      setVotes(exitPolls);

      getWriteups(game.number)
        .then((data) => {
          let { writeupA, writeupB } = data || {};
          return { writeupA, writeupB };
        })
        .then((cloudWriteups) => {
          setWriteups({
            writeupA: cloudWriteups.writeupA || writeups.writeupA,
            writeupB: cloudWriteups.writeupB || writeups.writeupB,
          });
        });
    });
  }, [emptyVoteBox, game]);

  if (!game) {
    return (
      <>
        <h1>I'm not aware of any game number {gameNumber}</h1>
        <p>
          Did you remember to put the game number in the url? As an example, try{" "}
          <a href={exampleUrl}>{exampleUrl}</a>
        </p>
      </>
    );
  } else {
    return (
      <>
        <Header gameNumber={gameNumber} />
        <Matchup
          game={game}
          votes={votes}
          setVotes={setVotes}
          writeups={writeups}
        />
      </>
    );
  }
};

export default MatchupPage;
